module.exports = __webpack_public_path__ + "h5/img/company-overview.8e36f19d.jpg";